import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import lookupTables from "../../data/lookup_tables.json";
import { V1Clinic } from "../../types/v1_schemas";

function AccessibilityTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  if (!providerA.clinicAccessibilityOffereds && !providerB.clinicAccessibilityOffereds) {
    return <></>;
  }

  const rowData = lookupTables.accessibilitySupports?.sort((s1, s2) => s1.description > s2.description ? 1 : -1).filter(f => f.text !== "Unknown").map((m) => {
    return {
      label: t(`${m.translate}`),
      compareA: !!providerA.clinicAccessibilityOffereds?.filter(f => f.lineageText === m.lineageText)[0],
      compareB: !!providerB.clinicAccessibilityOffereds?.filter(f => f.lineageText === m.lineageText)[0]
    };
  });

  return <CompareStripedRows rows={rowData} title={t("accessibilityTitle")} />;
}

export default AccessibilityTable;
